import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import U2000ComboBoxBase from '../../u2000Core/components/formControls/combobox/U2000ComboBoxBase';
import { NS } from '../U3204';
import type { U3204AccessibleMissionOption } from '../hooks/useU3204AccessibleMissionsHandlers';

interface U3204MissionSelectorProps {
  missions: U3204AccessibleMissionOption[];
  selectedMissionId: string | null;
  onChange: (missionId: string | null) => void;
  hasUserGroup: boolean;
  disabled?: boolean;
}

const U3204MissionSelector: React.FC<U3204MissionSelectorProps> = ({
  missions,
  selectedMissionId,
  onChange,
  hasUserGroup,
  disabled = false,
}) => {
  const { t } = useTranslation(NS);

  const selectedMission = useMemo(
    () => missions.find((mission) => mission.id === selectedMissionId) ?? null,
    [missions, selectedMissionId],
  );

  const hasNoMissions = missions.length === 0;

  return (
    <div>
      <label className="mb-1 block text-xs font-medium text-muted-foreground">{t('selectMission', { ns: NS })}</label>
      <U2000ComboBoxBase<U3204AccessibleMissionOption>
        data={missions}
        keyField="id"
        descField="label"
        value={selectedMission}
        onChange={(id) => onChange(id)}
        noneItemLabel={t('allMissions', { ns: NS })}
        disabled={disabled || !hasUserGroup || hasNoMissions}
        placeHolder={t('selectMissionPlaceholder', { ns: NS })}
      />
      {!hasUserGroup ? (
        <div className="mt-2 rounded-lg border border-border bg-muted/40 p-2 text-xs text-muted-foreground">
          <p>{t('emptyNoUserGroup', { ns: NS })}</p>
        </div>
      ) : hasNoMissions ? (
        <div className="mt-2 space-y-1 rounded-lg border border-border bg-muted/40 p-2 text-xs text-muted-foreground">
          <p>{t('noAccessibleMissions', { ns: NS })}</p>
          <Link to="/U3206" className="font-medium text-primary hover:underline">
            {t('goToUserGroups', { ns: NS })}
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default U3204MissionSelector;
